/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

import createStore from 'zustand';
import shallow from 'zustand/shallow';
import useProductsIM from 'hooks/useProductsIM';
import useInventoryEntryIM from 'hooks/useMovementsIM';
import { HeaderData, MovementProducts, ProductEntryManagement } from 'interfaces/productEntryManagement.interface';
import { ImProduct } from 'interfaces/imProduct.interface';
import { useState } from 'react';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { ENTRADA } from 'constants/constBd';
import useCrossingInvoices from 'hooks/useCrossingInvoices';

const defaultHeaderData = {
  remission: '',
  invoice: '',
  purchaseOrder: '',
  observations: '',
  documentTypeId: ENTRADA
};

export const productsEntryManagementStore = createStore<ProductEntryManagement>((set, get) => ({
  searchText: '',
  setSearchText: (searchText: string) => set({ searchText }),
  products: [],
  setProducts: (products: ImProduct[]) => set({ products }),
  headerData: defaultHeaderData,
  setHeaderData: (headerData: HeaderData) => set({ headerData }),
  cartItemCount: 0,
  incrementCartItemCount: () => {
    const count = get().cartItemCount + 1;
    set({ cartItemCount: count });
    return count;
  },
  cartItems: [],
  setCartItems: (cartItems) => set({ cartItems }),
  isLoadingSave: false,
  setIsLoadingSave: (isLoadingSave) => set({ isLoadingSave }),
  reset: () => set({ searchText: '', products: [], headerData: defaultHeaderData, cartItemCount: 0, cartItems: [] })
}));

const useProductsEntryManagementStore = () => {
  const [
    products,
    setProducts,
    cartItems,
    setCartItems,
    setIsLoadingSave,
    cartItemCount,
    incrementCartItemCount,
    headerData,
    setHeaderData,
    setSearchText
  ] = productsEntryManagementStore(
    (state) => [
      state.products,
      state.setProducts,
      state.cartItems,
      state.setCartItems,
      state.setIsLoadingSave,
      state.cartItemCount,
      state.incrementCartItemCount,
      state.headerData,
      state.setHeaderData,
      state.setSearchText
    ],
    shallow
  );
  const { getProducts: getProductService } = useProductsIM();
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const { showNotistack } = useCustomSnackbar();
  const { createMovement } = useInventoryEntryIM();
  const { update } = useCrossingInvoices();
  const saveMovement = (): void => {
    setIsLoadingSave(true);

    const data: MovementProducts[] = [];
    try {
      if (!headerData.purchaseOrder) {
        throw Error('Número de orden es obligatorio');
      }
      if (!headerData.invoice) {
        throw Error('Factura es obligatorio');
      }

      if (cartItems.length === 0) {
        throw Error('Debes agregar al menos un producto');
      }

      cartItems.forEach((item) => {
        if (!item.quantity || !item.unitCost) {
          throw Error('Producto a ingresar sin costo unitario o cantidad');
        }

        data.push({
          discountsWp: true,
          parentId: item.parentId,
          productId: item.productId,
          quantity: item.quantity,
          unitCost: item.unitCost,
          sku: item.sku
        });
      });

      const dataToSend = [
        {
          document: headerData,
          products: data
        }
      ];
      if (dataToSend[0].document.remission) {
        update(dataToSend);
      }
      createMovement(dataToSend)
        .then((response: boolean) => {
          if (response === true) {
            setCartItems([]);
            setProducts([]);
            setSearchText('');
            setHeaderData(defaultHeaderData);
            showNotistack({ message: 'La entrada se guardó correctamente' });
          } else {
            showNotistack({ message: 'Ocurrió un error' });
          }
        })
        .catch((err: any) => {
          console.log(err.reponse?.data);
          showNotistack({ message: 'Ocurrió un error' });
        })
        .finally(() => {
          setIsLoadingSave(false);
        });
    } catch (error) {
      showNotistack({ message: (error as any).message });
      setIsLoadingSave(false);
    }
  };

  return {
    products,
    getProducts: (page: number, limit: number, searchText: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        setIsLoadingProducts(true);

        getProductService(page, limit, searchText)
          .then((result: any) => {
            const produts: ImProduct[] = [];

            result?.products.map((product: ImProduct) => {
              if (product.type === 'variable') {
                product.variation?.map((variation: any) => {
                  produts.push({
                    name: variation.name,
                    parentId: Number(variation.parentId),
                    productId: Number(variation.productId),
                    quantity: Number(variation.stock_quantity),
                    sku: variation.sku,
                    stock: Number(variation.stock),
                    type: 'variación',
                    unitCost: product.unitCost
                  } as ImProduct);
                });
              } else {
                produts.push(product);
              }
            });

            setProducts(produts);
            resolve();
          })
          .catch((err) => reject(err))
          .finally(() => setIsLoadingProducts(false));
      });
    },
    isLoadingProducts,
    resetProducts: () => setProducts([]),
    cartItems,
    saveMovement,
    setCartItems,
    cartItemCount,
    incrementCartItemCount
  };
};

export default useProductsEntryManagementStore;
